import { builderChallenge } from 'src/components/challenge/builder';
import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { ChallengeDetail, ILinkedChallenges, IUser } from 'src/shared/models';

const {
  LINKED_CHALLENGES_DESCRIPTION,
  LINKED_CHALLENGE_TYPE,
  LINKED_CHALLENGE_ID,
} = ResourceTypeDetailEnum;

export const buildLinkedChallenges = (
  resource: IResourceList,
  user: IUser
): ILinkedChallenges => {
  const { idResource, score, name, i18nList, activate } = resource;

  let linkedChallenges: ILinkedChallenges;
  const challenges: ChallengeDetail[] = [];
  let points = score?.points || 0;
  let isCompleted = true;
  let isPartialDone = false;
  let challengeBuilded: ChallengeDetail;

  resource.resourceDetailList
    .filter(({ status, challenge }) => status && challenge)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value, challenge }) => {
      switch (idResourceTypeD) {
        case LINKED_CHALLENGES_DESCRIPTION:
          linkedChallenges = {
            ...linkedChallenges,
            description: value,
          };
          break;
        case LINKED_CHALLENGE_TYPE:
          linkedChallenges = {
            ...linkedChallenges,
            type: parseInt(value),
          };
          break;
        case LINKED_CHALLENGE_ID:
          challengeBuilded = builderChallenge(challenge, user);
          const { challengePoints, isChallengeCompleted } = challengeBuilded;

          isCompleted = isCompleted && isChallengeCompleted;
          isPartialDone = isPartialDone || false;
          points += challengePoints;
          challenges.push(challengeBuilded);

          break;
      }
    });

  return {
    ...linkedChallenges,
    challenges,
    i18nList,
    idResource,
    isCampaignActivator: activate,
    isCompleted,
    isPartialDone,
    points,
    title: name,
  };
};
